import React, { useState } from "react";
import { databaseKeys } from "../config";   // <-- Correct import
import { useNavigate } from 'react-router-dom';

export default function DatabaseKeyPage() {
  const navigate = useNavigate();
  const [key, setKey] = useState(sessionStorage.getItem("databaseKey") || "");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!key.trim()) {
      setError("Please enter a valid database key.");
      return;
    }

    sessionStorage.setItem("databaseKey", key.trim());
     navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6 flex items-center justify-center">
      <div className="max-w-full mx-auto bg-white rounded-lg shadow-lg p-8 w-full max-w-md text-center">

        <img
          src="https://cdn-icons-png.flaticon.com/512/4221/4221392.png"
          alt="Database Key"
          className="w-20 mx-auto mb-4"
        />

        <h1 className="text-2xl font-bold text-gray-800 mb-2">Quality Control</h1>
        <p className="text-gray-600 mb-6">Enter your Database Key to continue</p>

        <form onSubmit={handleSubmit} className="space-y-4">

          <select
            value={key}
            onChange={(e) => setKey(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg 
                       focus:ring-2 focus:ring-blue-400 
                       focus:border-blue-400 bg-white"
          >
            <option value="">-- Select Key --</option>

            {databaseKeys.map((keyOption) => (
              <option key={keyOption} value={keyOption}>
                {keyOption}
              </option>
            ))}
          </select>

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-500 to-blue-600 
                       hover:from-blue-600 hover:to-blue-700 text-white py-3 
                       rounded-lg font-semibold transition-all duration-200 
                       shadow-md hover:shadow-lg"
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}


// import React, { useState } from "react";

// const options = ["ERPIWXF2826CHN", "spflerp2O25", "erpsppipe","TRIALSPFL"];

// export default function DatabaseKeyPage() {
//   const [key, setKey] = useState(sessionStorage.getItem("databaseKey") || "");
//   const [error, setError] = useState("");

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!key.trim()) {
//       setError("Please enter a valid database key.");
//       return;
//     }
//     sessionStorage.setItem("databaseKey", key.trim());
//     // Navigate to login page
//     window.location.href = '/login';
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-6 flex items-center justify-center">
//       <div className="max-w-full mx-auto bg-white rounded-lg shadow-lg p-8 w-full max-w-md text-center">
//         <img
//           src="https://cdn-icons-png.flaticon.com/512/4221/4221392.png"
//           alt="Database Key"
//           className="w-20 mx-auto mb-4"
//         />
//         <h1 className="text-2xl font-bold text-gray-800 mb-2">Quality Control</h1>
//         <p className="text-gray-600 mb-6">Enter your Database Key to continue</p>

//         <form onSubmit={handleSubmit} className="space-y-4">
//           <select
//             value={key}
//             onChange={(e) => setKey(e.target.value)}
//             className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:border-blue-400 bg-white"
//           >
//             <option value="">-- Select Key --</option>
//             {options.map((keyOption) => (
//               <option key={keyOption} value={keyOption}>
//                 {keyOption}
//               </option>
//             ))}
//           </select>
//           {error && <p className="text-red-500 text-sm">{error}</p>}

//           <button
//             type="submit"
//             className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white py-3 rounded-lg font-semibold transition-all duration-200 shadow-md hover:shadow-lg"
//           >
//             Continue
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

